import { DoctorDetailInfoResponseDto } from "@/data/dto/admin/doctor-response-dto";
import { DoctorDetailInfoEntity } from "@/domain/entity/admin/doctor-detail-info-entity";
import { DoctorTreatmentSummaryMapper } from "./doctor-treatment-summary-mapper";
import { assertDoctorDetailInfoResponseDto } from "@/utils/validation";

export class DoctorDetailInfoMapper {
  static toEntity(dto: DoctorDetailInfoResponseDto): DoctorDetailInfoEntity {
    // AST 기반 타입 검증
    console.log(
      "[DoctorDetailInfoMapper] :: toEntity :: 입력 데이터:",
      JSON.stringify(dto, null, 2)
    );
    assertDoctorDetailInfoResponseDto(dto);
    return {
      name: dto.name,
      hospitalName: dto.hospital,
      screeningId: dto.screeningId,
      email: dto.email,
      memo: dto.memo || "",
      enrolledCount: dto.treatmentList.length,
      treatmentList: dto.treatmentList
        .map((treatment) => DoctorTreatmentSummaryMapper.toEntity(treatment))
        .sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        }),
      isSnExisting: dto.isSnExisting,
      isDeactivated: dto.isDeactivated,
    };
  }
}
